/* globals alert */

import React, { Component, Fragment } from 'react';

import Chip from '@material-ui/core/Chip';
import Select from '@material-ui/core/Select';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import MenuItem from '@material-ui/core/MenuItem';
import FormGroup from '@material-ui/core/FormGroup';
import Divider from '@material-ui/core/Divider';
import { apiPost } from '../brainApi';
import { getZ3PConfigValue, convertTime, getServiceEntity } from '../helper';

export default class NewBookingDialog extends Component {
  static prettyPrint(string) {
    const capitalized = string.charAt(0).toUpperCase() + string.slice(1);
    return capitalized.replace(/_/gi, ' ');
  }

  constructor(props) {
    super(props);
    this.state = {
      serviceVehicleId: '',
      clientLocationIds: [],
      limitTotalHours: 13.3,
      limitTotalTransitHours: null,
      limitScheduledWorks: 10,
      selectedScheduleTypes: [],
    };

    this.sortedClientLocations = Object.values(props.allClientLocations);
    this.sortedClientLocations.sort((a, b) =>
      a.short_name > b.short_name ? 1 : -1,
    );
  }

  componentDidMount() {
    const { defaultServiceVehicleId } = this.props;
    if (defaultServiceVehicleId) {
      this.setServiceVehicle(defaultServiceVehicleId);
    }
  }

  componentDidUpdate(prevProps) {
    const { serviceVehicleId } = this.state;
    const { defaultServiceVehicleId } = this.props;
    if (
      !serviceVehicleId &&
      defaultServiceVehicleId !== prevProps.defaultServiceVehicleId
    ) {
      this.setServiceVehicle(defaultServiceVehicleId);
    }
  }

  onCloseClear = () => {
    const { onClose } = this.props;
    onClose();
    this.clearState();
  };

  setServiceVehicle = (serviceVehicleId) => {
    const { clearDefaultServiceVehicleIdMethod } = this.props;
    clearDefaultServiceVehicleIdMethod();
    const { allServiceVehicleIds } = this.props;
    if (
      allServiceVehicleIds.includes(serviceVehicleId) ||
      serviceVehicleId === ''
    ) {
      this.setState({
        serviceVehicleId,
        limitTotalHours: 13.3,
        limitTotalTransitHours: null,
        limitScheduledWorks: 10,
      });
    }
  };

  setClientLocationIds = (clientLocationIds) => {
    const { allClientLocations } = this.props;
    const { serviceVehicleId } = this.state;
    this.setState({ clientLocationIds });
    if (clientLocationIds.length === 1) {
      const location = allClientLocations[clientLocationIds[0]];
      const defaultServiceVehicleId =
        location.default_mechanical_service_vehicle_id;
      if (!serviceVehicleId && defaultServiceVehicleId) {
        this.setServiceVehicle(defaultServiceVehicleId);
      }
    }
  };

  clientLocationSelectionRenderer = (values) => {
    const { allClientLocations } = this.props;
    switch (values.length) {
      case 0:
        return 'Client Locations';
      case 1:
        return allClientLocations[values[0]].long_name;
      default:
        return `${values.length} locations selected`;
    }
  };

  scheduleTypeSelectionRenderer = (values) => {
    if (!values || !values.length) {
      return 'Please select schedule types';
    }
    return (
      <div style={{ display: 'flex', flexWrap: 'wrap' }}>
        {values.map((value) => (
          <Chip key={value} label={value} style={{ margin: 2 }} />
        ))}
      </div>
    );
  };

  selectAllClientLocations = (selected) => {
    if (selected) {
      const { allClientLocations } = this.props;
      const allClientLocationIds = Object.values(allClientLocations).map(
        (cl) => cl.client_location_id,
      );
      this.setClientLocationIds(allClientLocationIds);
    } else {
      this.setClientLocationIds([]);
    }
  };

  selectState = (state, selected) => {
    const { allClientLocations } = this.props;
    const { clientLocationIds } = this.state;
    const clientLocationIdsWithState = Object.values(allClientLocations)
      .filter((cl) => cl.state === state)
      .map((cl) => cl.id);

    if (selected) {
      const newClientLocationIds = [
        ...new Set([...clientLocationIds, ...clientLocationIdsWithState]),
      ];
      this.setClientLocationIds(newClientLocationIds);
    } else {
      const newClientLocationIds = clientLocationIds.filter(
        (clId) => !clientLocationIdsWithState.includes(clId),
      );
      this.setClientLocationIds(newClientLocationIds);
    }
  };

  inputsAreValid = () => {
    const {
      serviceVehicleId,
      selectedScheduleTypes,
      limitTotalHours,
      limitScheduledWorks,
      limitTotalTransitHours,
    } = this.state;

    const { date } = this.props;

    const validLimits =
      limitTotalHours !== '' &&
      limitTotalHours >= 0 &&
      limitTotalHours <= 84 &&
      limitScheduledWorks !== '' &&
      limitScheduledWorks >= 0 &&
      !(limitTotalTransitHours < 0);

    return (
      date &&
      serviceVehicleId &&
      selectedScheduleTypes.length > 0 &&
      validLimits
    );
  };

  createBooking = () => {
    if (!this.inputsAreValid()) {
      alert('Input is invalid.');
    }
    const {
      serviceVehicleId,
      clientLocationIds,
      limitTotalHours,
      limitTotalTransitHours,
      limitScheduledWorks,
      selectedScheduleTypes,
    } = this.state;

    const { date, updateCalendar } = this.props;

    const data = {
      service_vehicle_id: serviceVehicleId,
      client_location_ids: clientLocationIds,
      start_time: `${date} ${convertTime(
        getZ3PConfigValue('time_range_min'),
        'militaryString',
      )}:00`,
      end_time: `${date} ${convertTime(
        getZ3PConfigValue('time_range_max'),
        'militaryString',
      )}:00`,
      offered_service_types: selectedScheduleTypes,
      created_by: 'Brain2 Admin',
      is_canceled: false,
      internal_note: 'Brain2 Admin',
      limit_total_hours: limitTotalHours,
      limit_total_driving_hours: limitTotalTransitHours,
      limit_scheduled_works: limitScheduledWorks,
      is_demand_based: clientLocationIds.length < 1,
    };

    return apiPost('/schedule', data).then((json) => {
      if (json.Status === 'Failure') {
        alert(`Error:\n\n${json.Message}`);
      } else {
        this.clearState();
        updateCalendar(json);
        this.onCloseClear();
        return;
      }

      if (json.Status === 'Failure') {
        alert(`Error:\n\n${json.Message}`);
      } else {
        alert(`Unknown Error:\n\n${JSON.stringify(json)}`);
      }
    });
  };

  clearState = () => {
    const { setDateMethod } = this.props;
    this.setState({
      serviceVehicleId: '',
      clientLocationIds: [],
      limitTotalHours: 13.3,
      limitTotalTransitHours: null,
      limitScheduledWorks: 10,
      selectedScheduleTypes: [],
    });
    setDateMethod('');
  };

  render() {
    const {
      serviceVehicleId,
      clientLocationIds,
      limitTotalHours,
      limitTotalTransitHours,
      limitScheduledWorks,
      selectedScheduleTypes,
    } = this.state;

    const {
      open,
      date,
      defaultServiceVehicleId,
      setDateMethod,
      allServiceVehicles,
      allServiceVehicleIds,
      allClientLocations,
      scheduleTypeNameToEmoji,
    } = this.props;

    const serviceVehicleIdToName = {};
    allServiceVehicles.forEach((sv) => {
      serviceVehicleIdToName[sv.id] = sv.name;
    });

    const clientLocationOptions = Object.values(allClientLocations).map(
      (cl) => ({
        id: cl.client_location_id,
        name: cl.short_name,
      }),
    );
    clientLocationOptions.sort((a, b) => (a.name > b.name ? 1 : -1));

    const allStates = [
      ...new Set(Object.values(allClientLocations).map((cl) => cl.state)),
    ];

    const serviceLocations = getZ3PConfigValue('service_locations');
    const hasWorkplaceServices = serviceLocations?.includes('workplace');

    return (
      <Dialog
        open={open}
        onClose={this.onCloseClear}
        aria-labelledby="form-dialog-title"
        scroll="body"
        fullWidth
      >
        <DialogTitle id="form-dialog-title">Add New Booking Date</DialogTitle>
        <DialogContent>
          <TextField
            id="date"
            type="date"
            value={date}
            onChange={(e) => setDateMethod(e.target.value)}
            fullWidth
          />
          <br />
          <br />
          {hasWorkplaceServices && (
            <>
              <Select
                id="client-locations"
                displayEmpty
                multiple
                value={clientLocationIds}
                onChange={(e) => this.setClientLocationIds(e.target.value)}
                fullWidth
                renderValue={this.clientLocationSelectionRenderer}
              >
                {this.sortedClientLocations.map((location) => (
                  <MenuItem
                    key={location.client_location_id}
                    value={location.client_location_id}
                  >
                    {location.long_name}
                  </MenuItem>
                ))}
              </Select>

              <Button
                variant="outlined"
                color="primary"
                size="small"
                onClick={() => this.selectAllClientLocations(true)}
              >
                Select All
              </Button>
              <Button
                variant="outlined"
                size="small"
                onClick={() => this.selectAllClientLocations(false)}
              >
                Deselect All
              </Button>
              <Divider />

              {allStates.map((state) => (
                <Fragment key={state}>
                  <Button
                    variant="outlined"
                    color="primary"
                    size="small"
                    onClick={() => this.selectState(state, true)}
                  >
                    Select {state}
                  </Button>
                  <Button
                    variant="outlined"
                    size="small"
                    onClick={() => this.selectState(state, false)}
                  >
                    Deselect {state}
                  </Button>
                  <Divider />
                </Fragment>
              ))}
            </>
          )}

          <TextField
            id="service-vehicle"
            select
            label={getServiceEntity()}
            value={defaultServiceVehicleId || serviceVehicleId}
            onChange={(e) => this.setServiceVehicle(e.target.value)}
            fullWidth
          >
            <MenuItem key="" value="" />
            {allServiceVehicleIds.map((svID) => (
              <MenuItem key={svID} value={svID}>
                {serviceVehicleIdToName[svID]}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            id="limit_total_hours"
            type="text"
            onChange={(e) => this.setState({ limitTotalHours: e.target.value })}
            value={limitTotalHours}
            label="Service Hours Limit"
            fullWidth
          />
          <TextField
            id="limit_total_driving_hours"
            type="text"
            onChange={(e) =>
              this.setState({ limitTotalTransitHours: e.target.value })
            }
            value={limitTotalTransitHours}
            label="Transit Hours Limit"
            fullWidth
          />
          <TextField
            id="limit_scheduled_works"
            type="text"
            onChange={(e) =>
              this.setState({ limitScheduledWorks: e.target.value })
            }
            value={limitScheduledWorks}
            label="Appointment Limit"
            fullWidth
          />
          <FormGroup>
            <Select
              id="schedule-types"
              displayEmpty
              multiple
              value={selectedScheduleTypes}
              onChange={(e) =>
                this.setState({ selectedScheduleTypes: e.target.value })
              }
              fullWidth
              renderValue={this.scheduleTypeSelectionRenderer}
              style={{ marginTop: '15px' }}
            >
              {Object.keys(scheduleTypeNameToEmoji).map((scheduleType) => (
                <MenuItem key={scheduleType} value={scheduleType}>
                  {scheduleType} {scheduleTypeNameToEmoji[scheduleType]}
                </MenuItem>
              ))}
            </Select>
          </FormGroup>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.onCloseClear} color="primary">
            Cancel
          </Button>
          <Button
            onClick={this.createBooking}
            color="primary"
            variant="contained"
            disabled={!this.inputsAreValid()}
          >
            Create
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}
